import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { defineMessage, useIntl } from 'react-intl';
import { RowActionMui } from '../../../../../../components/table/RowActionMui';

const verifyMatchMessage = defineMessage({
  id: 'audit.verifyMatch.actionTitle',
  defaultMessage: 'Verificar detección',
});

export interface VerifyMatchActionProps {
  onClick: () => void;
}

/**
 * Row action that opens the list-owned verify-match dialog for this detection.
 */
export function VerifyMatchAction({ onClick }: VerifyMatchActionProps) {
  const { $t } = useIntl();

  return (
    <RowActionMui title={$t(verifyMatchMessage)} onClick={onClick}>
      <FactCheckOutlinedIcon />
    </RowActionMui>
  );
}
